import moment from 'moment';
import getAsapLabel from 'base/utils/getAsapLabel';
import {
  HOUR_MINUTE_DAY_TIME,
  MILITARY_TIME,
  DATE_OUTPUT_FORMAT,
  DATE_INPUT_FORMAT
} from 'base/constants/timeFormat';

/**
 * input YYYY-MM-DD
 * output MMM D
 */
export const getDate = date => {
  return moment(date, DATE_INPUT_FORMAT).format(DATE_OUTPUT_FORMAT);
};

/**
 * input HH:mm
 * output h:mma
 */
export const getTime = time => {
  return moment(time, MILITARY_TIME).format(HOUR_MINUTE_DAY_TIME);
};

/**
 * Return the OrderSetting string base on the fulfillment option
 * Sensei 1 Jun 5, 2019 5:00 pm
 * ASAP (30 min)
 */
export const getTimeAndDateOrASAP = (
  requestedFulfillmentIsAsap,
  currentPrepTime,
  fulfillmentDate,
  fulfillmentTime
) => {
  if (requestedFulfillmentIsAsap) {
    return getAsapLabel(currentPrepTime);
  }
  if (fulfillmentDate && fulfillmentTime) {
    return `${getDate(fulfillmentDate)}, ${getTime(fulfillmentTime)}`;
  }
};
